<template>
  <div>
    <div class="row-info">
      <div class="row-info-title">
        设备信息<span class="edit-icon-div" v-if="infoData.dev_status != 'online'"><img class="width-full" src="../../assets/img/buttonedit.svg" alt="" @click="showUpdataDevModel"/></span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">设备名称</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.dev_name">
          <span class="row-info-contant-contant">{{ infoData.dev_name }}</span>
        </v-tooltip>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">设备KEY</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.dev_key">
          <span class="row-info-contant-contant">{{ infoData.dev_key }}</span>
        </v-tooltip>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">设备MAC</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.dev_mac">
          <span class="row-info-contant-contant">{{ infoData.dev_mac }}</span>
        </v-tooltip>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">产品名称</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.product_name">
          <span class="row-info-contant-contant">{{ infoData.product_name }}</span>
        </v-tooltip>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">产品标识</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.product_key">
          <span class="row-info-contant-contant">{{ infoData.product_key }}</span>
        </v-tooltip>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">设备状态</span>
        <span class="row-info-contant-contant">
          <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.dev_status == 'online' ? '在线' : '离线'">
            <span :class="infoData.dev_status == 'online' ? 'online' : 'offline'">{{ infoData.dev_status == 'online' ? '在线' : '离线' }}</span>
          </v-tooltip>
        </span>
      </div>
      <div v-if="infoData.dev_status == 'online'" class="row-info-contant">
        <span class="row-info-contant-title">{{ infoData.dev_status == 'online' ? '上线时间' : '上一次上线' }}</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.online_time || '未上线'">
          <span class="row-info-contant-contant">{{ infoData.online_time || '未上线' }}</span>
        </v-tooltip>
      </div>
      <div v-else class="row-info-contant">
        <span class="row-info-contant-title">{{ infoData.dev_status == 'online' ? '上一次离线' : '离线时间' }}</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.offline_time">
          <span class="row-info-contant-contant">{{ infoData.offline_time }}</span>
        </v-tooltip>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">创建时间</span>
        <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.created_at_str">
          <span class="row-info-contant-contant">{{ infoData.created_at_str }}</span>
        </v-tooltip>
      </div>

      <div class="row-info-contant">
        <span class="row-info-contant-title">分组名称</span>
        <!-- <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.group_name">
        </v-tooltip> -->
        <span v-if="infoData.group_name" class="row-info-contant-contant">{{ infoData.group_name }}</span>
        <span v-if="!infoData.group_id" class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="showDevToGroupModel">添加设备到分组</v-button></span>
        <span v-if="infoData.group_id" class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="showDevToGroupModel">编辑</v-button></span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">操作</span>
        <span class="row-info-contant-contant">
          <v-tooltip :enterable="false" :between-space="0" show-only-ellipsis :content="infoData.dev_name">
            <span class="handle-button"><v-button size="S" type="text" name="btn-text1" slot="reference" @click="showUpgradeModel()">固件升级</v-button></span>
          </v-tooltip>
        </span>
      </div>
    </div>
    <UpdataDevice :showInputDialog.sync="UpdataDevloading" :infoData="infoData" @getData="getData" ref="UpdataDev"></UpdataDevice>
    <AddDevToGroup :showInputDialog.sync="AddDevToGrouploading" ref="AddDevToGroup" :devId="devId" :groupId="groupId" @getData="getData"></AddDevToGroup>
    <Upgrade :showInputDialog.sync="Upgradeloading" :product_key="product_key" :device_key="device_key" ref="Del"></Upgrade>
  </div>
</template>

<script>
// import { copy } from "@/common/libs/utils";
import UpdataDevice from '@/components/device/updata-device.vue';
import AddDevToGroup from './add-devToGroup.vue';
import Upgrade from '@/components/device/upgrade.vue';

export default {
  components: { UpdataDevice, AddDevToGroup, Upgrade },
  props: {
    devName: {},
    devId: {},
    devKey: {}
  },
  data() {
    return {
      UpdataDevloading: false,
      AddDevToGrouploading: false,
      groupId: 0,
      device_key: '',
      product_key: '',
      infoData: {},
      Upgradeloading: false
    };
  },
  created() {
    this.getData();
    var _this = this;
    this.timer = setInterval(function() {
      _this.getData();
    }, 1000 * 60);
  },

  methods: {
    showUpdataDevModel() {
      this.UpdataDevloading = !this.UpdataDevloading;
    },
    showDevToGroupModel() {
      this.groupId = this.infoData.group_name ? this.infoData.group_id : 0;
      this.AddDevToGrouploading = !this.AddDevToGrouploading;
    },
    showUpgradeModel() {
      this.device_key = this.infoData.dev_key;
      this.product_key = this.infoData.product_key;
      this.Upgradeloading = !this.Upgradeloading;
    },
    async getData() {
      const subData = {
        id: this.devId
      };
      const res = await this.$getData('/td/td-iot-api/iot/dev/v1', subData);
      if (res.code === 0) {
        this.infoData = res.data;
      } else {
        if (res.code == '100410') {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
.online {
  color: #17cc82;
}
.offline {
  color: #f7421e;
}
</style>
